import { useRef } from "react";

/* Distinguishes short tap from long press (500ms threshold). Used on phone
   and WhatsApp targets so short tap fires the dialer / DM link and long
   press copies the number to clipboard with a toast. Works on both mouse
   and touch input via pointer events. */
export function useLongPress({ onShortTap, onLongPress, threshold = 500 }) {
  const timerRef = useRef(null);
  const triggeredLongRef = useRef(false);

  const start = (e) => {
    triggeredLongRef.current = false;
    timerRef.current = setTimeout(() => {
      triggeredLongRef.current = true;
      onLongPress?.(e);
    }, threshold);
  };
  const cancel = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };
  const release = (e) => {
    cancel();
    if (!triggeredLongRef.current) onShortTap?.(e);
  };

  return {
    onPointerDown: start,
    onPointerUp: release,
    onPointerLeave: cancel,
    onPointerCancel: cancel,
    onContextMenu: (e) => e.preventDefault(),
  };
}
